module.exports = __webpack_public_path__ + "img/espn-cric-info.a8b81734.png";